import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "searchbar__text" }
const _hoisted_2 = { class: "searchbar__text" }
const _hoisted_3 = {
  key: 2,
  class: "searchbar__item searchbar__item--sort"
}
const _hoisted_4 = { class: "searchbar__text" }

import { EventBus } from '@global-js/event-bus';
import { storeToRefs } from 'pinia';
import { useBreakpointStore } from 'src/store/breakpointsStore';
import { useTranslations } from 'src/storybook/src/composables/translations';
import { vTouchTarget } from 'src/directives/TouchTarget/touchTarget';
import DropdownHotelFilter from '@lmt-rpb/DropdownHotelFilter/DropdownHotelFilter.vue';
import FaIcon from '@lmt-rpb/Atoms/FaIcon/FaIcon.vue';
import { useFilters } from 'src/composables/useFIlters';

type Props = {
	/**
	 * Show map button
	 * @default true
	 */
	hasMap?: boolean;
	/**
	 * Show sort dropdown
	 * @default true
	 */
	hasSort?: boolean;
	/**
	 * Show search button
	 * @default false
	 */
	hasSearch?: boolean;
	/**
	 * Show filter button
	 * @default true
	 */
	hasFilter?: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchBar',
  props: {
    hasMap: { type: Boolean, default: true },
    hasSort: { type: Boolean, default: true },
    hasSearch: { type: Boolean, default: false },
    hasFilter: { type: Boolean, default: true }
  },
  emits: ["openFilterModal", "openSearchModal"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;
const { translate } = useTranslations();

const { isDesktop } = storeToRefs(useBreakpointStore());
const { filtersCount } = useFilters();

const handleMapClick = () => {
	EventBus.$emit('hotel:openMap');
};

const handleFilterClick = () => {
	emit('openFilterModal');
};

const handleSearchClick = () => {
	emit('openSearchModal');
};

return (_ctx: any,_cache: any) => {
  return (!_unref(isDesktop))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["searchbar", {
			'searchbar--one-column': !_ctx.hasSort && !_ctx.hasMap && !_ctx.hasSearch && _ctx.hasFilter,
			'searchbar--three-columns': _ctx.hasSort && _ctx.hasMap,
		}])
      }, [
        (_ctx.hasMap)
          ? _withDirectives((_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "searchbar__item searchbar__item--map",
              onClick: handleMapClick
            }, [
              _createVNode(FaIcon, {
                icon: ['fa-solid', 'fa-map'],
                class: "searchbar__icon"
              }),
              _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(translate)('searchBar.map')), 1 /* TEXT */)
            ])), [
              [_unref(vTouchTarget)]
            ])
          : _createCommentVNode("v-if", true),
        (_ctx.hasSearch)
          ? _withDirectives((_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "searchbar__item searchbar__item--search",
              onClick: handleSearchClick
            }, [
              _createVNode(FaIcon, {
                icon: ['fa-solid', 'fa-magnifying-glass'],
                class: "searchbar__icon"
              }),
              _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(translate)('searchBar.search')), 1 /* TEXT */)
            ])), [
              [_unref(vTouchTarget)]
            ])
          : _createCommentVNode("v-if", true),
        (_ctx.hasSort)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(DropdownHotelFilter)
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.hasFilter)
          ? _withDirectives((_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              class: "searchbar__item searchbar__item--filter",
              onClick: handleFilterClick
            }, [
              _createVNode(FaIcon, {
                icon: ['fa-solid', 'fa-sliders'],
                class: "searchbar__icon"
              }),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(translate)('searchBar.filter')) + " " + _toDisplayString(_unref(filtersCount) ? `(${_unref(filtersCount)})` : ''), 1 /* TEXT */)
            ])), [
              [_unref(vTouchTarget)]
            ])
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}
}

})